const languageToCountryCodeMapping = {
  en: 'gb',
  de: 'de',
  nl: 'nl',
  fr: 'fr',
  es: 'es',
  it: 'it',
  pt: 'pt',
  no: 'no',
  'pt-BR': 'br',
  sv: 'se',
  da: 'dk',
  ar: 'sa',
  ko: 'kr',
  he: 'il',
  pl: 'pl',
  ru: 'ru',
  tr: 'tr',
  ja: 'jp',
  zh: 'cn',
  'zh-HK': 'hk',
  'zh-TW': 'tw',
  fi: 'fi',
  hu: 'hu',
  id: 'id',
  ms: 'my',
  th: 'th'
}

/**
 * Returns the mapped country code for the specified language code.
 *
 * @param languageCode
 * @returns Matching country code
 */
export const getCountryCodeFromLanguage = (
  languageCode: string
): string | null => languageToCountryCodeMapping[languageCode]

export const countriesThatUse12HourFormat = new Set([
  'US',
  'CA',
  'NZ',
  'AU',
  'PH'
])
